import { fork } from 'redux-saga/effects';
import { renderFlow } from './render';
import { serviceReloadWatcher } from './serviceReload';
import logger from '../logger';

function* rootSaga() {
  logger.info(`Build version: ${process.env.REACT_APP_VERSION}`);
  yield fork(renderFlow);
  yield fork(serviceReloadWatcher);
}

export default rootSaga;
